import { DataTableColumnHeader } from "@/components/shared/tables/ColumnHeader";
import type { HeaderContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const ActionsHeader = ({ column }: HeaderContext<any, unknown>) => {
  const { t } = useTranslation();

  return (
    <DataTableColumnHeader
      column={column}
      className="px-4 text-end"
      title={t("exports.table.actions")}
    />
  );
};
